import {FC, useMemo} from 'react';
import {useDocumentCreationActions} from '@/components/new-document-creation/dialog/context/document-create-actions.hook';
import {getAccountLabel} from '@/components/new-document-creation/investor-accounts-list/get-account-label';
import {useConfig} from '@/contexts/config';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import {Investor, InvestorAccount} from '@/types/client-info';
import {ListItem} from '../list-item';

type Props = {
  account: InvestorAccount;
  investor: Investor;
};

export const InvestorAccountsListItem: FC<Props> = ({account, investor}) => {
  const {domainValueResolver} = useConfig();
  const {onCreateForExistingAccount} = useDocumentCreationActions();

  const accountLabel = useMemo(() => getAccountLabel(account, domainValueResolver), [account, domainValueResolver]);

  return (
    <ListItem
      data-testid={`select-account-${account.accountNo}`}
      trackingKey={WEB_CLICK_TRACKING_KEY.SELECT_ACCOUNT}
      onClick={() => onCreateForExistingAccount(investor, account.accountNo)}
    >
      <div className="flex flex-1 items-center justify-between gap-4 overflow-hidden">
        <div className="truncate leading-none">
          {/* eslint-disable-next-line i18next/no-literal-string */}
          {account.accountNo} - {accountLabel}
        </div>

        <div className="shrink-0 text-xs text-gray-500">
          {/* eslint-disable-next-line i18next/no-literal-string */}
          {account.dealerCode}-{account.repCode}
        </div>
      </div>
    </ListItem>
  );
};
